exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".icon-sm{width:.875em;height:auto}.icon-m{width:1.25em;height:auto}.icon-lg{width:1.75em;height:1.75em}.icon-xl{width:2em;height:auto}.icon-xxl{width:3em;height:auto}", ""]);
